'use client';

import { usePortalContext } from '@cloai/uikit';
import { Lalezar } from 'next/font/google';
import Link from 'next/link';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { PORTALS } from '@/.constants/portals';
import ShotikIcon from '@/public/icons/shotik.svg';
// import { HeaderSwitch } from '@/src/components/HeaderSwitch';
import { AvatarsDropdown } from '@/src/components/AvatarsDropdown';
import { HeaderClose } from '@/src/components/HeaderClose';
import {
  useProfileContext,
  useGTMContext,
  useMobileContext,
} from '@/src/providers';

const lalezar = Lalezar({
  weight: '400',
  subsets: ['latin'],
});

const styles = {
  header:
    'sm:min-w-[458px] sm:max-w-[458px] w-full m-auto flex items-center justify-end relative py-2',
  logoBtn:
    'absolute inset-0 m-auto pt-1 flex justify-center items-center size-fit',
  logo: `${lalezar.className} text-2xl tracking-wide`,
  button: 'flex items-center gap-1 bg-fill-quinary rounded-full px-2 py-1',
  icon: 'w-4 h-4',
  label: 'font-bold text-xs',
};

type THeaderProps = {
  isCloseButton?: boolean;
  onClickCloseButton?(): void;
  hrefCloseButton?: string;
};

export const HeaderWrapper: FC<THeaderProps> = ({
  isCloseButton = false,
  onClickCloseButton,
  hrefCloseButton,
}) => {
  const { isMobiles } = useMobileContext();
  return (
    <div
      className={twMerge(
        'absolute top-0 left-0 right-0 z-50 py-2 flex justify-center bg-fill-menu dark:bg-fill-menu bg-fill-menuBg px-5',
        isMobiles && 'pt-[100px]',
      )}
    >
      <Header
        isCloseButton={isCloseButton}
        onClickCloseButton={onClickCloseButton}
        hrefCloseButton={hrefCloseButton}
      />
    </div>
  );
};

export const Header: FC<THeaderProps> = ({
  isCloseButton,
  onClickCloseButton,
  hrefCloseButton,
}) => {
  const profile = useProfileContext();
  const sendGTM = useGTMContext();
  const { openPortal, currentPortal, closePortal } = usePortalContext();

  const handleClick = () => {
    sendGTM({
      event: 'Open_balance',
    });

    closePortal();
    openPortal(PORTALS.TopUpBalance);
  };

  const handleClickLogo = () => {
    if (!currentPortal) {
      return;
    }
    closePortal();
  };

  return (
    <header className={styles.header}>
      {/* {currentPortal !== PORTALS.GenerateImage && (
        <button className={styles.logoBtn} onClick={handleClickLogo}>
          <div className={styles.logo}>{profile?.brandName}</div>
        </button>
      )} */}
      {![PORTALS.GenerateImage, PORTALS.GeneratePhotoByPhoto].includes(
        currentPortal ?? '',
      ) && (
        <Link href="/" className={styles.logoBtn} onClick={handleClickLogo}>
          <div className={styles.logo}>{profile?.brandName}</div>
        </Link>
      )}
      <button className={styles.button} onClick={handleClick}>
        <ShotikIcon className={styles.icon} />
        <div className={styles.label}>{profile?.imageGenerationsLeft}</div>
      </button>

      {isCloseButton ? (
        <HeaderClose href={hrefCloseButton} onClick={onClickCloseButton} />
      ) : (
        <AvatarsDropdown />
      )}
    </header>
  );
};
